// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { LanguageSelectionComponent } from '@med/app/shared/modules/layout/components/language-selection/language-selection.component';
import { DividerModule } from '@med/app/shared/modules/divider/divider.module';
import { DropdownModule } from '@med/app/shared/modules/dropdown/dropdown.module';
import { ContainerModule } from '@med/app/shared/modules/container/container.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    DividerModule,
    DropdownModule,
    ContainerModule,
    CommonModule,
    TranslateModule,
    RouterModule,
  ],
  declarations: [
    LanguageSelectionComponent,
  ],
  exports: [
    LanguageSelectionComponent,
  ],
})

export class LayoutModule {
}
